module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Media/Back-636f79e6b5c9b3ecc30e29618de74a38.svg";